import { MillAdjustment } from "@/pages/adjustments/report/models/MillAdjustment";
import CommentIcon from "@mui/icons-material/Comment";
import { Grid2, IconButton } from "@mui/material";

export const CommentsColumn = ({ data }: { data: MillAdjustment }) => {
	return (
		<>
			<Grid2
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid2 size={{ md: 12, xs: 12 }}>
					<IconButton color="primary" size="small" disabled={!data?.Comments}>
						<CommentIcon />
					</IconButton>
				</Grid2>
			</Grid2>
		</>
	);
};
